import type { AddSubscriptionDataType } from "types/Subscription.type";

import { api } from "utils/api";

export const getSubscription = () => api.get<any>("/subscription/active");

export const addSubscription = (addSubscriptionData: AddSubscriptionDataType) =>
  api.post("/subscription", { ...addSubscriptionData });
